import * as consts from '../const';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    editor.Config.canvasCss += consts.component_switch_css;
    /* Component modal sponsors */
    var model = MODEL.extend({
        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'div',
            attributes:{
                'data-slg-type':'C-SWITCH',
            },
            classes:['switch'],
            
            components:[
                {
                    tagName:'input',
                    badgable:false,
                    selectable:false,
                    attributes:{
                        type:'checkbox',
                    },
                    classes:['checkbox']
                },
                {
                    tagName:'label',
                    classes:['label'],
                    badgable:false,
                    selectable:false,
                    components:[
                        {
                            tagName:'div',
                            classes:['ball']
                        }
                    ]
                }
            ]
        }   
    },{
        isComponent(el) {
            if(el && el.attributes && el.attributes['data-slg-type'] && el.attributes['data-slg-type'].value == 'C-SWITCH') {
                return {type: 'C-SWITCH'};
            }
        }
    });

    var view = VIEW.extend({
        events: {
            click:'click'
        },
        click: function(event){
            event.stopPropagation();
            let checked = this.el.querySelector(`input[type='checkbox']`).checked;
            this.el.querySelector(`input[type='checkbox']`).checked = !checked;
            editor.select(this.model);
        }
    });

    DOMC.addType('C-SWITCH',{
        model,
        view
    });


    /* BM.add('B-SWITCH', {
        label:"SWITCH",
        category:"ADVANCE COMPONENT",
        content: { 
          type: 'C-SWITCH',
         },
        media: '<i class="fas fa-toggle-on fa-5x"></i>',
    }); */
    
  };
  